import hyperdom from 'hyperdom'
import flatten from 'lowscore/flatten.js'
import scroller from './scroller.js'
import * as gtmDataLayer from './analytics/gtm/dataLayer.js'

export default class ServerErrorsPanel {
  constructor () {
    this.errors = {}
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  setErrors (errors, key='general') {
    this.errors[key] = errors
  }

  clear (key='general') {
    delete this.errors[key]
  }

  render () {
    if (Object.keys(this.errors).length > 0) {
      return scroller.scrollIntoView(<div class='message-error -strong'>
        <h2>Errors</h2>
        <ul class='u-unstyled'>
          {flatten(Object.values(this.errors)).map((error) => { return <li>{error.message || error}</li> })}
        </ul>
      </div>)
    }
  }
}
